import React, { useState } from "react";

import { Button } from "@aws-amplify/ui-react";
import { resetPassword } from "aws-amplify/auth";

interface ResendCodeButtonProps {
  username: string;
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
}

export const ResendCodeButton: React.FC<ResendCodeButtonProps> = ({ username, onSuccess, onError }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleResendCode = async () => {
    if (!username) {
      return;
    }

    setIsLoading(true);
    try {
      await resetPassword({ username });
      onSuccess?.();
    } catch (error) {
      onError?.(error);
      console.error("Error resending code:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      className="resend-code-button"
      onClick={handleResendCode}
      variation="link"
      size="small"
      isLoading={isLoading}
      loadingText="Sending..."
    >
      Resend Code
    </Button>
  );
};
